import { CalculationModelType, Degradation, QualityCriterionType } from '../enums';

export class CalculationInput {
    public contaminantCasNr: string;
    public contaminantName: string;
    public modelType: CalculationModelType;
    public degradation: Degradation;

    // degradation chain information
    public compoundCount: number;
    public contaminantIndexInChain: number;
    public degradationChainCompoundNames: string[] = [null, null, null, null];
    public degradationChainQualityCriteria: number[] = [null, null, null, null];
    public degradationChainQualityCriteriaType: QualityCriterionType[] = [null, null, null, null];

    // 'hidden' values
    public stoichiometricRatio: number[] = [null, null, null, null]; // Model 1,2,3,4,5
    public henrysConstant: number[] = [null, null, null, null]; // Model 3,4
    public freeDiffusionCoefficientInAir: number[] = [null, null, null, null]; // Model 3,4
    public freeDiffusionCoefficientInWater: number; // Model 1,2

    // Pollution source
    public sourceConcentration: number[] = [null, null, null, null]; // For model 1,2,3,4,5
    public sourceLength: number; // For model 1,2,3,5
    public sourceWidth: number; // For model 1,2,3,5
    public sourceInfiltration: number; // For model 1,2,3,5
    public plumeInfiltration: number; // For model 1,2,3,4,5
    public sourceRadius: number; // For model 4
    public concentrationZeroRadius: number; // For model 4

    // Vertical transport
    public sourceToAquiferDist: number; // For model 1,2,3
    public capillaryFringe: number; // For model 4
    public verticalPorosity: number; // For model 1,2,3,4
    public waterContent: number; // For model 3,4
    public verticalLongitudinalDispersivity: number; // For model 1,2,3
    public verticalTransversalDispersivity: number; // For model 3
    public verticalFirstOrderDegradationRate: number[] = [null, null, null, null]; // For model 1,2,3,4
    public fractureSpacing: number; // For model 2
    public fractureAperture: number; // For model 2
    public calculateFractureAperture = true; // For model 2
    public bulkHydraulicConductivity: number; // For model 2

    // Horizontal transport
    public aquiferThickness: number;
    public groundwaterVelocity: number;
    public calculateGroundwaterVelocity = true;
    public hydraulicConductivity: number;
    public hydraulicGradient: number;
    public horizontalPorosity: number;
    public horizontalFirstOrderDegradationRate: number[] = [null, null, null, null];
    public horizontalLongitudinalDispersivity: number;
    public horizontalTransversalDispersivity: number;
    public horizontalVerticalDispersivity: number;
    public aerobicDegradation = true;

    // Point(s) of Compliance
    public hasAdditionalPoC: boolean;
    public additionalPoCDistanceFromSource: number;
    public additionalPoCScreenLength: number;
    public abstractionRate: number;

    // Comments
    public pollutionSourceComment: string;
    public verticalTransportComment: string;
    public horizontalTransportComment: string;
    public pocComment: string;

    // Email notification
    public userEmail: string;
    public sendMailOnComputationFinished: boolean;

    public constructor(init: Partial<CalculationInput>) {
        Object.assign(this, init);
    }
}
